import { DeleteOutlined } from '@ant-design/icons';
import { DealStatusSelect } from '@repo/crm-atoms';
import {
  Button, Col, Flex, Row, Typography,
} from 'antd';
import { type DealUpdateNodeType } from 'automations/types/nodeTypes';
import { useCallback } from 'react';

import styles from './DealUpdateMenu.module.scss';

type Criteria = DealUpdateNodeType['data']['additionalOptions']['updateDeal']['criterias'][number];

export default function StatusTransition({
  criteria,
  currentIndex,
  updateExistingCriteria,
  deleteCriteriaAtIndex,
}: {
  criteria: Criteria;
  currentIndex: number;
  updateExistingCriteria: (criteria: Criteria, index: number) => void;
  deleteCriteriaAtIndex: (index: number) => void;
}) {
  const handleValueChange = useCallback((key: keyof Criteria, value: string) => {
    updateExistingCriteria({ ...criteria, [key]: value }, currentIndex);
  }, [updateExistingCriteria, criteria, currentIndex]);

  return (
    <Row className={styles.transitionRow}>
      <Col span={6}>
        {currentIndex === 0 && (
          <Typography.Text strong>When deal status changes</Typography.Text>
        )}
      </Col>
      <Col span={18}>
        <Flex gap={8} vertical>
          <Flex gap={8} align="center">
            <Typography.Text className={styles.transitionTitle}>From</Typography.Text>
            <DealStatusSelect
              value={criteria.fromValue}
              onChange={(value) => handleValueChange('fromValue', value)}
              className={styles.statusDropdown}
              withAnyOption
              showSearch
              optionFilterProp="label"
            />
          </Flex>
          <Flex gap={8} align="center">
            <Typography.Text className={styles.transitionTitle}>To</Typography.Text>
            <DealStatusSelect
              value={criteria.toValue}
              onChange={(value) => handleValueChange('toValue', value)}
              className={styles.statusDropdown}
              withAnyOption
              showSearch
              optionFilterProp="label"
            />
            {currentIndex !== 0 && (
              <Button
                type="link"
                onClick={() => deleteCriteriaAtIndex(currentIndex)}
                icon={<DeleteOutlined />}
                danger
              >
                Remove
              </Button>
            )}
          </Flex>
        </Flex>
      </Col>
    </Row>
  );
}
